import { CustomButton } from "@/src/lib/ui";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    updateCentreDetails,
    updateCurrentStep,
    appointmentSteps,
} from "@/src/lib/store/pet-ct-appointment-new/slice";
import { useRouter } from "next/router";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";

const SelectCentre = () => {
    const router = useRouter();
    const testDetails = useSelector(
        (state) => state?.appointmentNew?.testDetails
    );
    const dispatch = useDispatch();
    console.log(testDetails, "testDetails");

    const updateCentreDetailsHandler = (centre) => {

        if (centre.centreId) {
            dispatch(updateCentreDetails(centre));
            dispatch(updateCurrentStep(appointmentSteps.SELECT_DATE));
        }
    };

    const updateLocationDetailsHandler = (centre) => {
        if (centre.centreSlug) {
            window.open(`/locate-us/${centre.centreSlug}`, "_blank");
        }
    };

    return (
        <div>
            <p className="text-xs uppercase tracking-widest text-black font-medium md:mt-12 mt-5 md:mb-6 mb-0">
                Select Centre
            </p>
            {testDetails.centres.map((centre) => (
                <div
                    key={centre.centreId}
                    onClick={() =>  updateCentreDetailsHandler(centre)}
                    className="bg-white md:p-8 p-4 shadow-md md:my-6 my-3 flex flex-row justify-between items-center group hover:scale-105 transition-all duration-300 hover:border-primary/30 cursor-pointer"
                >
                    <div>
                        <div className="flex flex-row items-center gap-2">
                            <div className="md:text-lg text-sm font-semibold tracking-wide">
                                {centre.centreName}
                            </div>

                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    updateLocationDetailsHandler(centre);
                                }}
                                className="flex items-center gap-1 text-gray-500 hover:text-primary text-xs font-medium border border-gray-200 hover:border-primary/40 hover:bg-primary/5 rounded-full px-2.5 py-1 transition-all duration-300"
                            >
                                <Iconify
                                    icon={IconCode.outlinedLocation}
                                    width={14}
                                    height={14}
                                />
                                {centre?.cityName}
                            </div>
                        </div>
                        <div className="flex flex-row items-center gap-2">
                            <div className="text-gray-500 text-sm font-medium">
                                Test Charges:
                            </div>
                            <div className="line-through text-sm text-primary">
                                ₹{centre?.mrp}
                            </div>
                            <div className="text-sm font-medium">
                                ₹{centre?.rate}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row items-center gap-5">
                        <CustomButton
                            onClick={(e) => {
                                e.stopPropagation();
                                updateCentreDetailsHandler(centre);
                            }}
                            className="bg-gray-700 text-white !text-xs rounded-none font-normal group-hover:bg-primary transition-all duration-300 uppercase px-2 md:py-2.5 py-2 tracking-wider"
                        >
                            Select
                        </CustomButton>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SelectCentre;
